import { type FC } from 'react';
import Input, { type InputProps } from '2-core-elements/FormElements/Input';

interface SearchListingFilterInputProps {
    placeholder: string;
    prefixIcon?: InputProps['suffixIcon'];
    suffixIcon?: InputProps['suffixIcon'];
    onSuffixIconClick?: InputProps['onSuffixIconClick'];
    maxLength?: InputProps['maxLength'];
    handleOnKeyDown: InputProps['onKeyDown'];
    inputValue: string;
}


const SearchListingFilterInput: FC<SearchListingFilterInputProps> = ({
    placeholder,
    handleOnKeyDown,
    onSuffixIconClick,
    prefixIcon,
    suffixIcon,
    maxLength,
    inputValue,
}) => {
    return (
        <div className="listing-app-filter-item">
            <Input
                debounceTimeout={300}
                placeholder={placeholder}
                prefixIcon={prefixIcon}
                suffixIcon={suffixIcon}
                value={inputValue}
                onSuffixIconClick={onSuffixIconClick}
                maxLength={maxLength}
                type="search"
                onKeyDown={handleOnKeyDown}
            />
        </div>
    );
};

export default SearchListingFilterInput;
